@if (json()) {
  <div>
    <button mat-button (click)="onClickJson()">View json</button>
  </div>
}
